(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel.js') >= 0) return;  svs.modules.push('/modules/tickets/assets/javascripts/next/components/ticket-carousel/ticket-carousel.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const tickets = svs.tickets;
const _React = React,
  useCallback = _React.useCallback,
  useEffect = _React.useEffect,
  useMemo = _React.useMemo,
  useRef = _React.useRef,
  useState = _React.useState;
const Icon = svs.ui.ReactIcon;
const ImageMemo = tickets.next.components.ImageMemo;
const _tickets$next$compone = tickets.next.components.ticketCarousel.selection,
  getCarouselImageSourceKey = _tickets$next$compone.getCarouselImageSourceKey,
  getTicketImage = _tickets$next$compone.getTicketImage;
const _tickets$next$compone2 = tickets.next.components.ticketCarousel.layout,
  createCarouselItems = _tickets$next$compone2.createCarouselItems,
  createCarouselShadowStates = _tickets$next$compone2.createCarouselShadowStates,
  getBadgeSize = _tickets$next$compone2.getBadgeSize,
  getDesktopArrowOffset = _tickets$next$compone2.getDesktopArrowOffset,
  getDesktopVisibleSideCount = _tickets$next$compone2.getDesktopVisibleSideCount,
  getIntroItemLayout = _tickets$next$compone2.getIntroItemLayout;
const useCarouselIntro = tickets.next.components.ticketCarousel.useCarouselIntro;
const useCarouselMotion = tickets.next.components.ticketCarousel.useTicketCarouselMotion;
const useCarouselViewport = tickets.next.components.ticketCarousel.useCarouselViewport;
const PICK_EXIT_DURATION_MS = 360;
const MAX_PODIUM_OPACITY = 0.7;
const clamp = (value, min, max) => Math.min(Math.max(value, min), max);
const getCenteredOpacity = _ref => {
  let items = _ref.items,
    panelWidth = _ref.panelWidth;
  if (!(items !== null && items !== void 0 && items.length) || !panelWidth) {
    return MAX_PODIUM_OPACITY;
  }
  const closestDistanceFromCenter = items.reduce((closestDistance, item) => {
    const itemDistance = Math.abs((item === null || item === void 0 ? void 0 : item.x) || 0);
    return Math.min(closestDistance, itemDistance);
  }, Number.POSITIVE_INFINITY);
  const fadeDistance = Math.max(panelWidth * 0.5, 1);
  const centeredRatio = clamp(1 - closestDistanceFromCenter / fadeDistance, 0, 1);
  return centeredRatio * MAX_PODIUM_OPACITY;
};
const getPickExitItemLayout = _ref2 => {
  let isDesktop = _ref2.isDesktop,
    item = _ref2.item,
    pickExitNumber = _ref2.pickExitNumber;
  if (!pickExitNumber || item.number === pickExitNumber) {
    return item;
  }
  const direction = item.direction || (item.offset < 0 ? -1 : 1);
  const exitDistance = item.width * (isDesktop ? 0.72 : 0.82);
  return _objectSpread(_objectSpread({}, item), {}, {
    boxShadow: 'none',
    opacity: 0,
    scale: item.scale * 0.96,
    x: item.x + direction * exitDistance,
    y: item.y + (isDesktop ? item.height * 0.02 : 0)
  });
};
const TicketCarouselArrow = _ref3 => {
  let direction = _ref3.direction,
    isVisible = _ref3.isVisible,
    onMove = _ref3.onMove,
    panelWidth = _ref3.panelWidth,
    viewportWidth = _ref3.viewportWidth,
    visibleSideCount = _ref3.visibleSideCount;
  if (!isVisible) {
    return null;
  }
  const left = direction < 0;
  const arrowOffset = getDesktopArrowOffset({
    panelWidth,
    viewportWidth,
    visibleSideCount
  });
  return React.createElement("button", {
    "aria-label": left ? 'Visa förra lotten' : 'Visa nästa lotten',
    className: "qa-ticket-carousel-arrow-".concat(left ? 'left' : 'right', " ticket-carousel__arrow ticket-carousel__arrow--").concat(left ? 'left' : 'right'),
    onClick: event => {
      event.stopPropagation();
      if (event.detail === 0) {
        onMove(direction);
      }
    },
    onPointerDown: event => {
      event.stopPropagation();
      onMove(direction);
    },
    style: {
      left: "calc(50% ".concat(left ? '-' : '+', " ").concat(arrowOffset, "px)")
    },
    type: "button"
  }, React.createElement(Icon, {
    icon: left ? 'menu-left' : 'menu-right',
    size: "100"
  }));
};
const TicketCarouselItem = _ref4 => {
  let cssSelectors = _ref4.cssSelectors,
    image = _ref4.image,
    imageAltText = _ref4.imageAltText,
    isDesktop = _ref4.isDesktop,
    item = _ref4.item,
    onCenterClick = _ref4.onCenterClick,
    onItemClick = _ref4.onItemClick,
    onPick = _ref4.onPick,
    panelHeight = _ref4.panelHeight,
    panelWidth = _ref4.panelWidth;
  const badgeSize = getBadgeSize({
    isDesktop,
    panelHeight,
    panelWidth,
    scale: item.scale
  });
  const framedCssSelectors = cssSelectors ? "".concat(cssSelectors, " ticket-with-podium-image--framed") : 'ticket-with-podium-image--framed';
  return React.createElement("div", {
    "aria-hidden": !item.isSelected,
    className: "ticket-carousel__item ".concat(item.isSelected ? 'ticket-carousel__item--selected' : ''),
    "data-ticket-carousel-number": item.number,
    "data-ticket-carousel-selected": item.isSelected ? 'true' : 'false',
    onClick: !item.isSelected && onItemClick ? event => onItemClick(event, item.number) : undefined,
    style: {
      width: "".concat(item.width, "px"),
      height: "".concat(item.height, "px"),
      zIndex: item.zIndex,
      opacity: item.opacity,
      boxShadow: item.boxShadow,
      transform: "translate3d(calc(-50% + ".concat(item.x, "px), calc(-50% + ").concat(item.y, "px), 0) scale(").concat(item.scale, ")")
    }
  }, React.createElement("div", {
    className: "ticket-carousel__card"
  }, React.createElement(ImageMemo, {
    cssSelectors: framedCssSelectors,
    image: _objectSpread(_objectSpread({}, image), {}, {
      altText: "".concat(imageAltText, " ").concat(item.number)
    })
  }), React.createElement("div", {
    "aria-hidden": "true",
    className: "ticket-carousel__number",
    style: {
      width: "".concat(badgeSize, "px"),
      height: "".concat(badgeSize, "px"),
      fontSize: "".concat(Math.max(10, badgeSize * 0.54), "px")
    }
  }, item.number), Boolean(item.isSelected && onPick) && React.createElement("button", {
    "aria-label": "Valj lott ".concat(item.number),
    className: "qa-ticket-carousel-pick ticket-carousel__pick",
    onClick: event => onCenterClick(event, item.number),
    type: "button"
  }, React.createElement("span", {
    className: "ticket-carousel__sr-only"
  }, "Valj lott ", item.number))));
};
const TicketCarousel = _ref5 => {
  let _ref5$availableWidth = _ref5.availableWidth,
    availableWidth = _ref5$availableWidth === void 0 ? 0 : _ref5$availableWidth,
    image = _ref5.image,
    initialSelectedNumber = _ref5.initialSelectedNumber,
    cssSelectors = _ref5.cssSelectors,
    ticketName = _ref5.ticketName,
    ticketType = _ref5.ticketType,
    skins = _ref5.skins,
    variations = _ref5.variations,
    onPick = _ref5.onPick,
    pickRequest = _ref5.pickRequest,
    onSelectedNumberChange = _ref5.onSelectedNumberChange,
    onShadowStatesChange = _ref5.onShadowStatesChange,
    onPodiumOpacityChange = _ref5.onPodiumOpacityChange,
    frameMetrics = _ref5.frameMetrics,
    _ref5$panelWidth = _ref5.panelWidth,
    panelWidth = _ref5$panelWidth === void 0 ? 0 : _ref5$panelWidth,
    _ref5$panelHeight = _ref5.panelHeight,
    panelHeight = _ref5$panelHeight === void 0 ? 0 : _ref5$panelHeight,
    _ref5$panelLiftPx = _ref5.panelLiftPx,
    panelLiftPx = _ref5$panelLiftPx === void 0 ? 0 : _ref5$panelLiftPx,
    _ref5$surfaceWidth = _ref5.surfaceWidth,
    surfaceWidth = _ref5$surfaceWidth === void 0 ? 0 : _ref5$surfaceWidth,
    _ref5$surfaceHeight = _ref5.surfaceHeight,
    surfaceHeight = _ref5$surfaceHeight === void 0 ? 0 : _ref5$surfaceHeight;
  const pickExitTimeoutRef = useRef(null);
  const handledPickRequestIdRef = useRef(null);
  const _useState = useState(null),
    _useState2 = _slicedToArray(_useState, 2),
    pickExitNumber = _useState2[0],
    setPickExitNumber = _useState2[1];
  const safePanelWidth = Math.max(panelWidth, 1);
  const safePanelHeight = Math.max(panelHeight, 1);
  const _useCarouselViewport = useCarouselViewport(),
    isDesktop = _useCarouselViewport.isDesktop,
    viewportWidth = _useCarouselViewport.viewportWidth;
  const arrowAvailableWidth = availableWidth || viewportWidth;
  const isPickExiting = Boolean(pickExitNumber);
  const imageSource = useMemo(() => getCarouselImageSourceKey({
    image,
    skins,
    variations
  }), [image, skins, variations]);
  const ticketTitle = ticketName || ticketType;
  const imageAltText = (image === null || image === void 0 ? void 0 : image.altText) || ticketTitle || 'Ticket';
  const visibleSideCount = useMemo(() => getDesktopVisibleSideCount({
    isDesktop,
    viewportWidth
  }), [isDesktop, viewportWidth]);
  const _useCarouselIntro = useCarouselIntro({
      imageSource,
      isDesktop
    }),
    finishIntro = _useCarouselIntro.finishIntro,
    introProgress = _useCarouselIntro.introProgress;
  const handlePickAfterExit = useCallback(ticketNumber => {
    if (!onPick || pickExitTimeoutRef.current) {
      return;
    }
    setPickExitNumber(ticketNumber);
    pickExitTimeoutRef.current = window.setTimeout(() => {
      pickExitTimeoutRef.current = null;
      onPick(ticketNumber);
    }, PICK_EXIT_DURATION_MS);
  }, [onPick]);
  const _useCarouselMotion = useCarouselMotion({
      finishIntro,
      imageSource,
      initialSelectedNumber,
      onPick: onPick ? handlePickAfterExit : undefined,
      onSelectedNumberChange
    }),
    handleCenterClick = _useCarouselMotion.handleCenterClick,
    handleItemClick = _useCarouselMotion.handleItemClick,
    handleKeyDown = _useCarouselMotion.handleKeyDown,
    handlePointerCancel = _useCarouselMotion.handlePointerCancel,
    handlePointerDown = _useCarouselMotion.handlePointerDown,
    handlePointerMove = _useCarouselMotion.handlePointerMove,
    handlePointerUp = _useCarouselMotion.handlePointerUp,
    isDragging = _useCarouselMotion.isDragging,
    moveBy = _useCarouselMotion.moveBy,
    position = _useCarouselMotion.position,
    selectedNumber = _useCarouselMotion.selectedNumber;
  const carouselItems = useMemo(() => createCarouselItems({
    isDesktop,
    panelHeight: safePanelHeight,
    panelWidth: safePanelWidth,
    position,
    visibleSideCount
  }), [isDesktop, position, safePanelHeight, safePanelWidth, visibleSideCount]);
  const displayedCarouselItems = useMemo(() => carouselItems.map(item => getIntroItemLayout({
    isDesktop,
    item,
    progress: introProgress
  })), [carouselItems, isDesktop, introProgress]);
  const renderedCarouselItems = useMemo(() => displayedCarouselItems.map(item => getPickExitItemLayout({
    isDesktop,
    item,
    pickExitNumber
  })), [displayedCarouselItems, isDesktop, pickExitNumber]);
  const podiumOpacity = useMemo(() => getCenteredOpacity({
    items: renderedCarouselItems,
    panelWidth: safePanelWidth
  }), [renderedCarouselItems, safePanelWidth]);
  const shadowStates = useMemo(() => createCarouselShadowStates({
    frameMetrics,
    items: renderedCarouselItems,
    panelLiftPx,
    panelWidth: safePanelWidth,
    surfaceHeight,
    surfaceWidth
  }), [frameMetrics, panelLiftPx, renderedCarouselItems, safePanelWidth, surfaceHeight, surfaceWidth]);
  useEffect(() => {
    if (onShadowStatesChange) {
      onShadowStatesChange(shadowStates);
    }
  }, [onShadowStatesChange, shadowStates]);
  useEffect(() => {
    if (onPodiumOpacityChange) {
      onPodiumOpacityChange(podiumOpacity);
    }
  }, [onPodiumOpacityChange, podiumOpacity]);
  useEffect(() => () => {
    if (onShadowStatesChange) {
      onShadowStatesChange([]);
    }
  }, [onShadowStatesChange]);
  useEffect(() => () => {
    if (pickExitTimeoutRef.current) {
      window.clearTimeout(pickExitTimeoutRef.current);
      pickExitTimeoutRef.current = null;
    }
  }, []);
  useEffect(() => {
    const requestId = pickRequest === null || pickRequest === void 0 ? void 0 : pickRequest.id;
    if (!requestId || handledPickRequestIdRef.current === requestId) {
      return;
    }
    handledPickRequestIdRef.current = requestId;
    handlePickAfterExit(pickRequest.ticketNumber || selectedNumber);
  }, [handlePickAfterExit, pickRequest, selectedNumber]);
  return React.createElement("div", {
    "aria-label": ticketTitle ? "".concat(ticketTitle, " carousel") : 'Ticket carousel',
    "aria-roledescription": "carousel",
    className: [cssSelectors, 'ticket-carousel', 'ticket-carousel--draggable', isDesktop ? 'ticket-carousel--desktop' : 'ticket-carousel--mobile', isDragging ? 'ticket-carousel--dragging' : undefined, isPickExiting ? 'ticket-carousel--picking' : undefined].filter(Boolean).join(' '),
    "data-selected-ticket": selectedNumber,
    draggable: false,
    onDragStart: event => event.preventDefault(),
    onKeyDown: handleKeyDown,
    onPointerCancel: isPickExiting ? undefined : handlePointerCancel,
    onPointerDown: isPickExiting ? undefined : handlePointerDown,
    onPointerMove: isPickExiting ? undefined : handlePointerMove,
    onPointerUp: isPickExiting ? undefined : handlePointerUp,
    role: "group",
    tabIndex: 0
  }, React.createElement("div", {
    className: "ticket-carousel__track"
  }, renderedCarouselItems.map(item => React.createElement(TicketCarouselItem, {
    cssSelectors: cssSelectors,
    image: getTicketImage({
      image,
      skins,
      ticketNumber: item.number,
      variations
    }),
    imageAltText: imageAltText,
    isDesktop: isDesktop,
    item: item,
    key: item.key,
    onCenterClick: handleCenterClick,
    onItemClick: handleItemClick,
    onPick: onPick ? handlePickAfterExit : undefined,
    panelHeight: safePanelHeight,
    panelWidth: safePanelWidth
  }))), React.createElement(TicketCarouselArrow, {
    direction: -1,
    isVisible: isDesktop && !isPickExiting,
    onMove: moveBy,
    panelWidth: safePanelWidth,
    viewportWidth: arrowAvailableWidth,
    visibleSideCount: visibleSideCount
  }), React.createElement(TicketCarouselArrow, {
    direction: 1,
    isVisible: isDesktop && !isPickExiting,
    onMove: moveBy,
    panelWidth: safePanelWidth,
    viewportWidth: arrowAvailableWidth,
    visibleSideCount: visibleSideCount
  }));
};
setGlobal('svs.tickets.next.components.ticketCarousel.TicketCarousel', TicketCarousel);

 })(window);